<template>
  <div class="edi_setting">
    <iframe
      :src="mani_auto_url"
      referrerpolicy="no-referrer-when-downgrade"
      seamless
      style="border:0"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: 'EdiSettingsManagementIndex',
  data() {
    return {
      mani_auto_url: process.env.VUE_APP_EDI_MANAGEMENTS_URL
    }
  },
}
</script>

<style scoped lang="scss">
.edi_setting{
  display: flex;
  flex-direction: column;
  width: 100%;
}
.edi_setting iframe{
  flex-grow: 1;
  padding-bottom: 30px;
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
}
</style>

